'use client';

import { Spinner } from '@uikit';

import { useGetCampaignsProjectsQuery } from '@query/launchpad';

import { CampaignCard } from './Card';

const Page = () => {
  const { data } = useGetCampaignsProjectsQuery();

  if (!data) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spinner size="lg" />
      </div>
    );
  }

  const activeCampaigns = data.filter((campaign) => campaign.status.toLowerCase() === 'active');
  const pastCampaigns = data.filter((campaign) => campaign.status.toLowerCase() === 'ended');

  return (
    <main className="main-container max-w-[1144px] mx-auto px-4 sm:px-6 lg:px-8">
      <h1 className="my-8 md:mb-16 text-[32px] md:text-[40px] text-center font-medium">
        Magic Square Campaigns
      </h1>
      <h3 className="flex items-center mb-6 text-[32px] font-semibold">
        <div className="w-3 h-3 mr-2 rounded-full bg-green-700" />
        Active campaigns
      </h3>
      <section className="grid grid-cols-1 gap-4 mb-16 md:grid-cols-2 xl:grid-cols-1">
        {activeCampaigns.map((campaign) => (
          <CampaignCard campaign={campaign} key={campaign.id} />
        ))}
      </section>
      <h3 className="flex items-center mb-6 text-[32px] font-semibold">
        <div className="w-3 h-3 mr-2 rounded-full bg-yellow-600" />
        Past campaigns
      </h3>
      <section className="grid grid-cols-1 gap-4 mb-16 md:grid-cols-2 xl:grid-cols-1">
        {pastCampaigns.map((campaign) => (
          <CampaignCard campaign={campaign} key={campaign.id} />
        ))}
      </section>
    </main>
  );
};

export default Page;
